import { InfoPage } from '@/components/info-page';
import { EntityTable } from '@/components/table/entity-table';
import { TableErrorState } from '@/components/table/table-error-state';
import { getAssessmentContents } from '@/lib/api-calls';
import { useErrorToast } from '@/lib/error-handling';
import { AssessmentContent } from '@airreading/common/data';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { isAirAdmin } from '@airreading/common';
import { validateRouteRole } from '@/lib/routing';
import { lessonsSectionTabs } from '../-components/tabs';

export const Route = createFileRoute('/_layout/lessons/assessment-contents/')({
  beforeLoad: validateRouteRole(isAirAdmin),
  component: AssessmentContentsIndex,
});

const columnHelper = createColumnHelper<AssessmentContent>();
const columns = [
  columnHelper.accessor('name', { header: 'Name' }),
  columnHelper.accessor('format', {
    header: 'Format',
  }),
  columnHelper.accessor('words', {
    header: 'Words',
    cell: ({ getValue }) => {
      return <div>{getValue().join(', ')}</div>;
    },
  }),
  columnHelper.accessor('maxErrorsAllowed', {
    header: 'Max errors allowed',
  }),
  columnHelper.accessor('internalOrder', {
    header: 'Internal order',
  }),
  // columnHelper.accessor((row) => row, {
  //   id: 'actions',
  //   header: '',
  //   cell: ({ getValue }) => (
  //     <>
  //       <CreateEditAssessmentContent
  //         trigger={
  //           <Button variant={'outline'} size={'sm'}>
  //             Edit
  //           </Button>
  //         }
  //         key={getValue().id}
  //         from={getValue()}
  //       />
  //     </>
  //   ),
  // }),
];

function AssessmentContentsIndex() {
  const { data: assessmentContents = [], isPending, error, refetch } = useQuery(getAssessmentContents());

  useErrorToast(error, 'Error loading assessment contents. Please try again.');

  const table = useReactTable({
    data: assessmentContents,
    columns,
    getCoreRowModel: getCoreRowModel(),
    defaultColumn: {
      enableSorting: false,
    },
  });

  return (
    <>
      <InfoPage
        headerText="Assessment contents"
        headerActions={
          <>{/* <CreateEditAssessmentContent trigger={<Button>Create assessment content</Button>} /> */}</>
        }
        tabs={lessonsSectionTabs()}
      >
        <EntityTable
          table={table}
          isLoading={isPending}
          hasError={!!error}
          errorState={<TableErrorState refetchAction={refetch} />}
        />
      </InfoPage>
    </>
  );
}
